import { API_BASE_URL } from '../../env';
import { ApiReturnType } from '../../interfaces/api/api';

export default {
  getSuppliers: (): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/stock/suppliers`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getProductTypes: (): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/stock/product-types`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
};
